import  { useEffect, useState, useRef, FunctionComponent } from "react";
import styles from "./AddUsers.module.css";
import TextInput from "../../Components/TextInput/InputText";
import AddModal from "../../Components/Modals/AddModal/AddModal";
import { emailValidate } from "../../Values/validatorsnew";
import { connect, useDispatch } from "react-redux";
import {
  updateTeams,
  updateDesignations,
  createUser,
  updateContactEditUsers,
  updateApiDataEditUsers,
  updateTasksEditUsers,
} from "../../Services/organizations";
import Loading from "../../Components/Loading/Loading";
import { showSnackbarAction } from "../../Redux/actions";
import { AiOutlineClose } from "react-icons/ai";
import {
  updateTeamsAction,
  updateDesignationsAction,
} from "../../Redux/actions";
import { useLocation } from "react-router-dom";
import { EditAdminUserDetails, EditUserDetails, fetchProfilesData } from "../../Services/users";
import { themeColors } from "../../Components/theme";
import Label from "../../Components/Label";
import axios from "axios";
import { url } from "../../Values/constants";
import PhoneInput, { CountryData } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import "../../theme-vars.css";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import DropDownText from "../../Components/DropDownText/DropDownText";
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import PhoneNumberWrapper from "../../Components/TextInput/PhoneNumberWrapper";
import DropDownPopup from "../../Components/DropDownText/DropDownPopup";

type props = {
  user: any;
  history: any;
  organization: any;
  organizationId: string;
  organizationUsers: any[];
  branchList: any[];
  theme: any;
};

const AddUsers: FunctionComponent<props> = ({
  history,
  organization,
  organizationId,
  organizationUsers,
  branchList,
  theme,
}) => {
  const dispatcher = useDispatch();
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const location: any = useLocation();
  const [inputTextPassword, setInputTextPassword] = useState(false);
  const firstNameRef: any = useRef();
  const lastNameRef: any = useRef();
  const numberRef: any = useRef();
  const emaileRef: any = useRef();
  const branchRef: any = useRef();
  const passwordRef: any = useRef("");
  const [teamSelected, setTeamSelected] = useState<any>({ label: "Select", value: "Select" });
  const [designationSelected, setDesignationSelected] = useState<any>({ label: "Select", value: "Select" });
  const [reportingTo, setReportingTo] = useState<any>({ label: "Select", value: "Select" });
  const [profileSelected, setProfileSelected] = useState<any>({ label: "Select", value: "Select" });
  const [brancheSelected, setBranchSelected] = useState<any>({ label: "Select", value: "Select" });
  const [teams, setTeams] = useState<any[]>([]);
  const [branches, setBranches] = useState<any[]>([]);
  const [designations, setDesignations] = useState<any[]>([]);
  const [userTeams, setUserTeams] = useState<any[]>([]);
  const [userDesignations, setUserDesignations] = useState<any[]>([]);
  const [profile, setProfile] = useState<{ label: string; value: string }[]>([]);
  const [reporting, setReporting] = useState<any>({ label: "", value: "" });
  const [load, setLoad] = useState(false);
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [showDesigModal, setShowDesigModal] = useState(false);
  const [booleanSendEmail, setBooleanSendEmail] = useState(false);
  const [pwd, setPwd] = useState("");
  const [reportingToProfile, setReportingToProfile] = useState<any>({ label: "", value: "" });
  const [phoneCountryCode, setPhoneCountryCode] = useState('in');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [finalPhoneNumber, setFinalPhoneNumber] = useState(location?.state?.detail?.contact_no ? location?.state?.detail?.contact_no : "");

  const handlePhoneChange = (value: string, country: CountryData) => {
    // Extract the country code and phone number from the input value
    if (value.startsWith(country?.dialCode)) {
      const phoneNumberWithoutCode = value.substring(country?.dialCode.length);
      setFinalPhoneNumber(phoneNumberWithoutCode);
    } else {
      setFinalPhoneNumber(value);
    }
    setPhoneCountryCode(country?.dialCode);
    setPhoneNumber(value)
  };

  useEffect(() => {
    let teamList: any = [];
    let designationList: any = [];
    organizationUsers?.map(item => {
      if (item.team) {
        teamList.push(item.team);
      }
      if (item.designation) {
        designationList.push(item.designation);
      }
    })
    setUserTeams(teamList);
    setUserDesignations(designationList);
  }, [organizationUsers])

  useEffect(() => {
    let allTeams = [...userTeams, ...organization.teams];
    let allDesignations = [...userDesignations, ...organization.designations];
    let uniqueTeams = Array.from(new Set(allTeams));
    let uniqueDesignations = Array.from(new Set(allDesignations));
    setTeams(uniqueTeams);
    setDesignations(uniqueDesignations);
    setBranches(branchList);
    const unSubProfile = fetchProfilesData((data: string[]) => {
      // Ensure profile is an array of { label, value }
      const formatted = Array.isArray(data)
        ? data.map((item: any) =>
          typeof item === "string"
            ? { label: item, value: item }
            : item
        )
        : [];
      setProfile(formatted);
    });
    return () => {
      unSubProfile();
    };
    // eslint-disable-next-line
  }, [organization, userTeams, userDesignations]);

  useEffect(() => {
    if (location.state !== undefined) {

      setDesignationSelected({
        label: location.state.detail.designation,
        value: location.state.detail.designation,
      });
      setProfileSelected({
        label: location.state.detail.profile,
        value: location.state.detail.profile,
      });
      setTeamSelected({
        label: location.state.detail.team,
        value: location.state.detail.team,
      })
      setReportingTo({
        label: location.state.detail.reporting_to,
        value: location.state.detail.reporting_to,
      })
      setBranchSelected({
        label: location.state.detail.branch,
        value: location.state.detail.branch,
      })
    }
    // eslint-disable-next-line
  }, [designations, profile]);

  useEffect(() => {
    // Change from [{}] to []
    let data: any = [];
    let items: any = [];
    if (organizationUsers) {
      organizationUsers.forEach((item: any, index: number) => {
        data.push({
          label: `${item.user_first_name} ${item.user_last_name} (${item.user_email})`,
          value: item.user_email,
        });
        items.push({
          label: item.profile,
          value: item.user_email,
        });
      });
      setReporting(data);
      setReportingToProfile(items);
    }
  }, [organizationUsers]);

  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
  }, []);

  const handleProfileChange = (e: any) => {
    const selectedValue = e.target.value;
    const selectedObj = profile.find((item: any) => item.value === selectedValue) || { label: "Select", value: "Select" };
    setProfileSelected(selectedObj);
  };

  const handleReportingTo = (e: any) => {
    const selectedValue = e.target.value;
    const selectedObj = reporting.find((item: any) => item.value === selectedValue) || { label: "Select", value: "Select" };
    setReportingTo(selectedObj);
  };

  const handleCheck = () => {
    if (firstNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Enter First Name!!", "error"));
      return false;
    } else if (lastNameRef.current.value === "") {
      dispatcher(showSnackbarAction("Enter Last Name!!", "error"));
      return false;
    } else if (finalPhoneNumber === "") {
      dispatcher(showSnackbarAction("Enter Phone Number!!", "error"));
      return false;
    } else if (emaileRef.current.value === "") {
      dispatcher(showSnackbarAction("Enter Email!!", "error"));
      return false;
    } else if (
      teamSelected.label === "Select" ||
      teamSelected.label === "+ New Team"
    ) {
      dispatcher(showSnackbarAction("Select Team!!", "error"));
      return false;
    } else if (
      designationSelected.label === "Select" ||
      designationSelected.label === "+ New Designation"
    ) {
      dispatcher(showSnackbarAction("Select Designation!!", "error"));
      return false;
    } else if (profileSelected.label === "Select") {
      dispatcher(showSnackbarAction("Select Profile!!", "error"));
      return false;
    } else if (reporting.length === 0) {
      return true;
    } else if (reportingTo.value === "Select") {
      dispatcher(showSnackbarAction("Select Reporting to!!", "error"));
      return false;
    } else if (
      brancheSelected.label === "Select" ||
      brancheSelected.label === "+ New Branch"
    ) {
      dispatcher(showSnackbarAction("Enter Branch!!", "error"));
      return false;
    } else {
      return true;
    }
  };

  const create = (e: any) => {
    e.preventDefault();
    const val = handleCheck();
    let activeUsers = organizationUsers.filter(
      (item) => item.status === "ACTIVE"
    );
    const reporting_to = reporting.length === 0 ? "" : reportingTo.value;
    if (val) {
      if (!profile.some(p => p.value === profileSelected.value)) {
        dispatcher(showSnackbarAction("Invalid Profile!!", "error"));
      } else {
        setLoad(true);
        if (organization.trial_period === true) {
          createUser(
            emaileRef.current.value,
            firstNameRef.current.value,
            lastNameRef.current.value,
            teamSelected.label,
            reporting_to,
            finalPhoneNumber,
            phoneCountryCode == "in" ? 91 : parseInt(phoneCountryCode),
            designationSelected.label,
            brancheSelected.label === "Select" ||
              brancheSelected.label === "+ New Branch"
              ? ""
              : brancheSelected.value,
            activeUsers.length < Number(organization.org_trial_period_users_licenses)
              ? "ACTIVE"
              : "INACTIVE",
            profileSelected.value,
            dispatcher,
            history,
            organizationId,
            organization.admin_first_name + " " + organization.admin_last_name,
            organization.country,
            organization.state,
            false,
            (data: boolean) => setLoad(data),
            reportingToProfile,
            (data: boolean) => setBooleanSendEmail(data),
            (data: any) => setPwd(data),
          );
        }
        else {
          createUser(
            emaileRef.current.value,
            firstNameRef.current.value,
            lastNameRef.current.value,
            teamSelected.label,
            reporting_to,
            finalPhoneNumber,
            phoneCountryCode == "in" ? 91 : parseInt(phoneCountryCode),
            designationSelected.label,
            brancheSelected.label === "Select" ||
              brancheSelected.label === "+ New Branch"
              ? ""
              : brancheSelected.value,
            activeUsers.length < Number(organization.no_of_employees)
              ? "ACTIVE"
              : "INACTIVE",
            profileSelected.value,
            dispatcher,
            history,
            organizationId,
            organization.admin_first_name + " " + organization.admin_last_name,
            organization.country,
            organization.state,
            false,
            (data: boolean) => setLoad(data),
            reportingToProfile,
            (data: boolean) => setBooleanSendEmail(data),
            (data: any) => setPwd(data),
          );
        }
      }
    }
  };

  useEffect(() => {
    if (booleanSendEmail) {
      sendResetPasswordEmail();
    }
  }, [booleanSendEmail]);

  const sendResetPasswordEmail = async () => {
    let email = emaileRef.current.value.toLowerCase()
    let firstName = firstNameRef.current?.value;
    let lastName = lastNameRef.current?.value;
    if (email !== "") {
      try {
        if (email) {
          setLoad(true);
          const resetPasswordEmailApiData = {
            "template_name": "Password_Reset_Notification",
            "replaceable_params": [
              { "%#username#%": `${firstName} ${lastName}` },
              { "%#password#%": pwd }
            ],
            "email": email
          }
          await axios.post(
            url + '/email/sendEmail',
            resetPasswordEmailApiData
          );
          setLoad(false);
          dispatcher(
            showSnackbarAction(
              "Password reset information have been sent on you registered email id",
              "success"
            )
          );
          history.push("/");
        }
      } catch (error) {
        console.log("reset error", error);
      }
    } else {
      dispatcher(showSnackbarAction("Please Enter Your Email!", "error"));
    }
  }

  const adminEditCheck = () => {
    if (firstNameRef.current.value === "") {
      firstNameRef.current.value = location.state.detail.user_first_name;
    }
    if (lastNameRef.current.value === "") {
      lastNameRef.current.value = location.state.detail.user_last_name;
    }
    if (finalPhoneNumber === "") {
      setFinalPhoneNumber(location.state.detail.contact_no);
    }
    if (
      designationSelected.label === "Select" ||
      teamSelected.label === "+ New Designation"
    ) {
      designationSelected.label = location.state.detail.designation;
    }
    if (profileSelected.label === "Select") {
      profileSelected.label = location.state.detail.profile;
    }
    if (inputTextPassword === true) {
      if (passwordRef.current.value === "") {
        dispatcher(
          showSnackbarAction(
            "Password is Required!!",
            "error"
          )
        );
        return;
      }
    }
    return true;
  };

  const EditCheck = () => {
    if (firstNameRef.current.value === "") {
      firstNameRef.current.value = location.state.detail.user_first_name;
    }
    if (lastNameRef.current.value === "") {
      lastNameRef.current.value = location.state.detail.user_last_name;
    }
    if (finalPhoneNumber === "") {
      setFinalPhoneNumber(location.state.detail.contact_no);
    }
    if (
      designationSelected.label === "Select" ||
      teamSelected.label === "+ New Designation"
    ) {
      designationSelected.label = location.state.detail.designation;
    }
    if (profileSelected.label === "Select") {
      profileSelected.label = location.state.detail.profile;
    }
    if (reportingTo.value === "Select") {
      reportingTo.value = location.state.detail.reporting_to;
    }
    if (
      teamSelected.label === "Select" ||
      teamSelected.label === "+ New Team"
    ) {
      teamSelected.label = location.state.detail.team;
    }
    if (inputTextPassword === true) {
      if (passwordRef.current.value === "") {
        dispatcher(
          showSnackbarAction(
            "Password is Required!!",
            "error"
          )
        );
        return;
      }
    }
    return true;
  };

  const adminEdit = (e: any) => {
    e.preventDefault();
    const val = adminEditCheck();
    if (val) {
      if (emaileRef.current.value !== location.state.detail?.user_email) {
        if (inputTextPassword === false) {
          const isConfirmed = window.confirm("Are you sure you want to change Email Id?");
          if (isConfirmed) {
            setInputTextPassword(true);
          }
          else {
            emaileRef.current.value = location.state.detail?.user_email;
          }
        }
        else {
          setLoad(true);
          setInputTextPassword(false);
          sendResetPasswordEmail();
          updateUserAuth();
          //user email in contacts collection   
          updateContactEditUsers(
            location.state.detail.user_email,
            location.state.detail.organization_id,
            emaileRef.current?.value.toLowerCase()
          );
          //update in apidData collection
          updateApiDataEditUsers(
            location.state.detail.admin_email_id,
            location.state.detail.organization_id,
            emaileRef.current?.value.toLowerCase()
          )
          //update in Tasks collection
          updateTasksEditUsers(
            location.state.detail.admin_email_id,
            location.state.detail.organization_id,
            emaileRef.current?.value.toLowerCase()
          )
          EditAdminUserDetails(
            location.state.detail.uid,
            firstNameRef.current.value,
            lastNameRef.current.value,
            finalPhoneNumber,
            designationSelected.label,
            profileSelected.value,
            dispatcher,
            finalPhoneNumber !== location.state.detail.contact_no ? true : false,
            (data: boolean) => setLoad(data),
            history,
            emaileRef.current.value
          );
        }
      }
      else {
        setLoad(true);
        EditAdminUserDetails(
          location.state.detail.uid,
          firstNameRef.current.value,
          lastNameRef.current.value,
          finalPhoneNumber,
          designationSelected.label,
          profileSelected.value,
          dispatcher,
          finalPhoneNumber !== location.state.detail.contact_no ? true : false,
          (data: boolean) => setLoad(data),
          history,
          emaileRef.current.value
        );
      }
    }
  };

  const edit = (e: any) => {
    e.preventDefault();
    const val = EditCheck();
    const reporting_to = reporting.length === 0 ? "" : reportingTo.value;
    if (val) {
      if (!profile.some(p => p.value === profileSelected.value)) {
        dispatcher(showSnackbarAction("Invalid Profile!!", "error"));
      }
      else {
        if (emaileRef.current.value !== location.state.detail?.user_email) {
          if (inputTextPassword === false) {
            const isConfirmed = window.confirm("Are you sure you want to change Email Id?");
            if (isConfirmed) {
              setInputTextPassword(true);
            }
            else {
              emaileRef.current.value = location.state.detail?.user_email;
            }
          }
          else {
            setLoad(true);
            setInputTextPassword(false);
            sendResetPasswordEmail();
            updateUserAuth();
            //user email in contacts collection   
            updateContactEditUsers(
              location.state.detail.user_email,
              location.state.detail.organization_id,
              emaileRef.current?.value.toLowerCase()
            );
            //update in apidData collection
            updateApiDataEditUsers(
              location.state.detail.admin_email_id,
              location.state.detail.organization_id,
              emaileRef.current?.value.toLowerCase()
            )
            //update in Tasks collection
            updateTasksEditUsers(
              location.state.detail.admin_email_id,
              location.state.detail.organization_id,
              emaileRef.current?.value.toLowerCase()
            )
            EditUserDetails(
              location.state.detail.uid,
              firstNameRef.current.value,
              lastNameRef.current.value,
              finalPhoneNumber,
              designationSelected.label,
              profileSelected.value,
              reporting_to,
              teamSelected.label,
              dispatcher,
              finalPhoneNumber !== location.state.detail.contact_no
                ? true
                : false,
              (data: boolean) => setLoad(data),
              history,
              reportingToProfile,
              brancheSelected.label === "Select" ||
                brancheSelected.label === "+ New Branch"
                ? location.state.detail.branch
                  ? location.state.detail.branch
                  : ""
                : brancheSelected.label,
              emaileRef.current.value
            );
          }
        }
        else {
          setLoad(true);
          EditUserDetails(
            location.state.detail.uid,
            firstNameRef.current.value,
            lastNameRef.current.value,
            finalPhoneNumber,
            designationSelected.label,
            profileSelected.value,
            reporting_to,
            teamSelected.label,
            dispatcher,
            finalPhoneNumber !== location.state.detail.contact_no
              ? true
              : false,
            (data: boolean) => setLoad(data),
            history,
            reportingToProfile,
            brancheSelected.label === "Select" ||
              brancheSelected.label === "+ New Branch"
              ? location.state.detail.branch
                ? location.state.detail.branch
                : ""
              : brancheSelected.label,
            emaileRef.current.value
          );
        }
      }
    }
  };

  const updateUserAuth = async () => {
    const bodyData = {
      uid: location?.state?.detail?.uid,
      newEmail: emaileRef.current?.value,
      newPassword: passwordRef.current?.value
    }
    try {
      const repUpdateUserAuth = await axios.post(
        `${url}/utils/firebase-updateUser`, bodyData);
      // handle response
    } catch (error) {
      // handle error
    }
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  return (
    <>
      <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
        {load && <Loading />}
        {isMobile && (
          <div
            className="d-flex flex-row w-100 px-4 pt-4"
          >
            <h5
              style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}
            >
              {location.state !== undefined
                ? "Edit User Details"
                : "Add User Details"}
            </h5>
          </div>
        )}
        <div
          className="w-100 d-flex flex-column gap-2 px-4"
          style={{
            padding: isMobile ? '0' : '',
            maxWidth: isMobile ? '100vw' : undefined,
            margin: isMobile ? '0' : '0 auto',
            overflowY: isMobile ? 'auto' : undefined,
            maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
          }}
        >
          <form
            className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
            style={{
              ...cardContainerStyles,
              padding: isMobile ? '16px' : '32px',
              boxSizing: 'border-box',
              minHeight: isMobile ? 'auto' : undefined,
              marginBottom: isMobile ? '50px' : 0,
            }}
          >
            <Grid container spacing={isMobile ? 2 : 3}>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="First Name"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={firstNameRef}
                  value={
                    location.state ? location.state.detail.user_first_name : ""
                  }
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Last Name"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  value={
                    location.state ? location.state.detail.user_last_name : ""
                  }
                  ref={lastNameRef}
                  required={true}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <PhoneNumberWrapper
                  title="Mobile Number"
                  country={phoneCountryCode || 'in'}
                  value={location.state ? `${location.state.detail.admin_contact_code}+${location.state.detail.contact_no}` : phoneNumber}
                  handlePhoneChange={handlePhoneChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextInput
                  title="Email"
                  style={{ backgroundColor: "#fff", width: '100%' }}
                  ref={emaileRef}
                  validator={emailValidate}
                  required={true}
                  value={location.state ? location.state.detail.user_email : ""}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownPopup
                  title={" + New Designation"}
                  option={designations}
                  setDetails={() => setShowDesigModal(true)}
                  value={designationSelected.value === "Select" ? "" : designationSelected.value}
                  onChange={(val) => {
                    setDesignationSelected({ label: val, value: val });
                  }}
                  disabled={location.state !== undefined && location.state.detail.profile === "Admin" ? true : false}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="Profile"
                  options={profile}
                  value={profileSelected.value === "Select" ? "" : profileSelected.value}
                  onChange={handleProfileChange}
                  required
                  labelKey="label"
                  valueKey="value"
                  disabled={location.state !== undefined && location.state.detail.profile === "Admin" ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownPopup
                  title={" + New Team"}
                  option={teams}
                  setDetails={() => setShowTeamModal(true)}
                  value={teamSelected.value === "Select" ? "" : teamSelected.value}
                  onChange={(val) => {
                    setTeamSelected({ label: val, value: val });
                  }}
                  disabled={false}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownText
                  title="Reporting To"
                  options={reporting}
                  value={reportingTo.value === "Select" ? "" : reportingTo.value}
                  onChange={handleReportingTo}
                  required
                  labelKey="label"
                  valueKey="value"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DropDownPopup
                  title={" + New Branch"}
                  option={branches}
                  setDetails={() => setShowBranchModal(true)}
                  value={brancheSelected.value === "Select" ? "" : brancheSelected.value}
                  onChange={(val) => {
                    setBranchSelected({ label: val, value: val });
                  }}
                  disabled={false}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                {inputTextPassword === true && (
                  <TextInput
                    title="Password"
                    style={{ backgroundColor: "#fff", width: '100%' }}
                    ref={passwordRef}
                  />
                )}
              </Grid>
              {/* Remove submit button from inside form for mobile */}
              {!isMobile && (
                <Grid item xs={12} style={{ marginTop: 12 }}>
                  {location.state !== undefined ? (
                    <StyledSubmitButton
                      onClick={(e) =>
                        location.state?.detail?.profile === "Admin" ? adminEdit(e) : edit(e)
                      }
                      themeMode={themeMUI.palette.mode}
                    >
                      {load ? (
                        <span style={{ display: "flex", justifyContent: "center" }}>
                          <Circles color="#fff" height={20} width={20} />
                        </span>
                      ) : (
                        <>Update</>
                      )}
                    </StyledSubmitButton>
                  ) : (
                    <StyledSubmitButton
                      onClick={(e) => create(e)}
                      themeMode={themeMUI.palette.mode}
                    >
                      {load ? (
                        <span style={{ display: "flex", justifyContent: "center" }}>
                          <Circles color="#fff" height={20} width={20} />
                        </span>
                      ) : (
                        <>Submit</>
                      )}
                    </StyledSubmitButton>
                  )}
                </Grid>
              )}
            </Grid>
          </form>
        </div>
        {isMobile && (
          <Box
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              bgcolor: "white",
              p: 2,
              borderTop: "1px solid #ddd",
              boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
              zIndex: 100,
            }}
          >
            {location.state !== undefined ? (
              <StyledSubmitButton
                onClick={(e) =>
                  location.state?.detail?.profile === "Admin" ? adminEdit(e) : edit(e)
                }
                themeMode={themeMUI.palette.mode}
                isMobile={isMobile}
              >
                {load ? (
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    <Circles color="#fff" height={20} width={20} />
                  </span>
                ) : (
                  <>Update</>
                )}
              </StyledSubmitButton>
            ) : (
              <StyledSubmitButton
                onClick={(e) => create(e)}
                themeMode={themeMUI.palette.mode}
                isMobile={isMobile}
              >
                {load ? (
                  <span style={{ display: "flex", justifyContent: "center" }}>
                    <Circles color="#fff" height={20} width={20} />
                  </span>
                ) : (
                  <>Submit</>
                )}
              </StyledSubmitButton>
            )}
          </Box>
        )}
      </div>
      {showTeamModal && (
        <>
          <AddModal
            show={showTeamModal}
            heading={"Create Team"}
            subHeading={"Enter Name"}
            close={() => setShowTeamModal(false)}
            onSave={(value: string) => {
              updateTeams(
                value,
                setLoad,
                organizationId,
                (data: boolean) => {
                  dispatcher(updateTeamsAction(value));
                  setShowTeamModal(data);
                  setTeamSelected({ label: value, value });
                },
                dispatcher
              );
            }}
          />
        </>
      )}
      {showBranchModal && (
        <>
          <AddModal
            show={showBranchModal}
            heading={"Create Branch"}
            subHeading={"Enter Name"}
            close={() => setShowBranchModal(false)}
            onSave={(value: string) => {
              setBranches(prev => {
                if (!prev.some(b => b === value || (b.label && b.label === value))) {
                  return [...prev, value];
                }
                return prev;
              });
              setBranchSelected({ label: value, value });
              setShowBranchModal(false);
            }}
          />
        </>
      )}
      {showDesigModal && (
        <>
          <AddModal
            show={showDesigModal}
            heading={"Create Designation"}
            subHeading={"Enter designation"}
            close={() => setShowDesigModal(false)}
            onSave={(value) => {
              updateDesignations(
                value,
                setLoad,
                organizationId,
                (data: boolean) => {
                  dispatcher(updateDesignationsAction(value));
                  setShowDesigModal(data);
                  setDesignationSelected({ label: value, value });
                },
                dispatcher
              );
            }}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organization: state.organization,
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    branchList: state.branchList.data,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(AddUsers);
